(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("anteros-react", ["react", "lodash", "axios"], factory);
	else if(typeof exports === 'object')
		exports["anteros-react"] = factory(require("react"), require("lodash"), require("axios"));
	else
		root["anteros-react"] = factory(root["React"], root["lodash"], root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_1522__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition